// extracted by mini-css-extract-plugin
module.exports = {"AppIcon":"AppIcon_AppIcon__2Y6_d","IconWrapper":"AppIcon_IconWrapper__13-zE","IconLabel":"AppIcon_IconLabel__26j1f"};